import { useState, useRef, useEffect, useMemo } from "react"
import withStyles from "react-jss"
import globalStyles from "./styles/globalStyles"
import { PullQuote } from "./layouts"
import useWindowSize from "./hooks/useWindowSize"

const styles = {
  ...globalStyles,
  app: {
    margin: 0,
    padding: 0,
  },
}

const App = ({ classes }) => {
  const quoteNo = useMemo(() => {
    let id = 0 // Display first one by default
    if (window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search)
      const quote = params.get("quote")
      if (quote) {
        const quoteId = Number(quote)
        if (quoteId >= 1 && quoteId <= 5) {
          id = quoteId
        } else {
          id = 1
        }
      }
    }
    return id
  }, [])

  // Set Article's Iframe height dynamically --------------------------
  const ref = useRef(null)
  const { width } = useWindowSize()
  const [projectHeight, setProjectHeight] = useState(100)

  const updateProjectHeight = () => {
    if (ref.current && ref.current.offsetHeight) {
      setProjectHeight(ref.current.offsetHeight)
    }
  }

  useEffect(() => {
    window.addEventListener("load", updateProjectHeight)
    return () => window.removeEventListener("load", updateProjectHeight)
  }, [])

  useEffect(() => {
    updateProjectHeight()
  }, [width])

  useEffect(() => {
    if (window.parent) {
      const data = {
        height: projectHeight,
        type: "embed-size",
      }
      window.parent.postMessage(data, "*")
    }
  }, [projectHeight])

  return (
    <main className={classes.app}>
      <PullQuote id={quoteNo} ref={ref} />
    </main>
  )
}

export default withStyles(styles)(App)
